import { render, staticRenderFns } from "./mains.vue?vue&type=template&id=fe43e764&scoped=true"
import script from "./mains.vue?vue&type=script&lang=js"
export * from "./mains.vue?vue&type=script&lang=js"
import style0 from "./mains.vue?vue&type=style&index=0&id=fe43e764&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe43e764",
  null
  
)

export default component.exports